<template>
  <div class="setting-layout layout-page">
    <div class="tabs">
      <Tabs v-model="pageIndex" line-width="56px" color="#353945" title-active-color="#353945" title-inactive-color="#9FA4AD" @change="chagneTab">
        <Tab :title="$t('pageTitle.password')">
          <div class="layout-main">
            <router-view v-if="pageIndex == 0"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.userAuth')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 1"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.address')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 2"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('pageTitle.tradeSetting')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 3"></router-view>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant';
export default {
  components: {
    Tabs,
    Tab
  },
  data() {
    return {
      pageIndex: 0
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let name = this.$route.name
      switch(name) {
        case 'password': this.pageIndex = 0; break
        case 'userAuth': this.pageIndex = 1; break
        case 'address': this.pageIndex = 2; break
        case 'tradeSetting': this.pageIndex = 3; break
      }
    },
    chagneTab() {
      let name = this.pageIndex == 0 ? 'password' : 
                 this.pageIndex == 1 ? 'userAuth' :
                 this.pageIndex == 2 ? 'address' : 'tradeSetting'
      if(name) {
        this.$router.push({
          name: name
        })
      }
    }
  }
}
</script>